import Icon from "../icons/icon";
import { useState } from "react";
import { useSession } from "next-auth/react";
import { slugify } from "@/lib/helpers";
import Image from "next/image";
import Check from "../icons/lib/check";
import Copy from "../icons/lib/copy";
import toast from "react-hot-toast";

import { ACCOUNT_PROFILE } from "@/constants/routes";

const ShareLinks = ({ dark, artistSocials}: any) => {
  // hooks
  const session = useSession();

  const [copied, setCopied] = useState(false);

  const allSocialsNull = artistSocials
    ? Object.values(artistSocials).every((value) => value === null)
    : true;

  // actions
  const handleCopyLink = () => {
    navigator.clipboard.writeText(getShareUrl());
    setCopied(true);
    toast.success("Link copied.");
  };

  const getShareUrl = () => {
    if (window.location.href.includes(ACCOUNT_PROFILE)) {
      return window.location.href.replace(/\/account\/profile/,`/creators/${slugify(session.data?.user.artist.name)}/${session.data?.user.artistId}`);
    } else {
      return `${window.location.href}`;
    }
  };

  const fill = dark ? "fill-white" : "fill-black";
  return (
    <div className="grid gap-2 grid-rows-2 space-y-2">
      <div className="space-y-4">
        <span className="font-bold text-base">Share</span>
        <div className="flex space-x-4 justify-center divide-backgroundLight">
          {!allSocialsNull ? (
            <>
              {artistSocials.soundcloud && (
                <div className="flex">
                  <a
                    id="socials-icon-soundcloud"
                    href={artistSocials.soundcloud}
                    className="relative w-10 h-10"
                    target="blank"
                  >
                    <Image
                      layout="fill"
                      src="/assets/icons/soundcloud.svg"
                      className="cursor-pointer"
                      alt="soundcloud"
                      blurDataURL="/assets/icons/soundcloud.svg"
                      placeholder="blur"
                    />
                  </a>
                </div>
              )}
              {artistSocials.youtube && (
                <div className="flex">
                  <a
                    id="socials-icon-youtube"
                    href={artistSocials.youtube}
                    className="relative w-10 h-10"
                    target="blank"
                  >
                    <Image
                      layout="fill"
                      src="/assets/icons/youtube.svg"
                      className="cursor-pointer"
                      alt="youtube"
                      blurDataURL="/assets/icons/youtube.svg"
                      placeholder="blur"
                    />
                  </a>
                </div>
              )}
              {artistSocials.tiktok && (
                <div className="flex">
                  <a
                    id="socials-icon-tiktok"
                    href={artistSocials.tiktok}
                    className="relative w-10 h-10"
                    target="blank"
                  >
                    <Image
                      layout="fill"
                      src="/assets/icons/tiktok.svg"
                      className="cursor-pointer"
                      alt="tiktok"
                      blurDataURL="/assets/icons/tiktok.svg"
                      placeholder="blur"
                    />
                  </a>
                </div>
              )}
              {artistSocials.facebook && (
                <div className="flex">
                  <a
                    id="socials-icon-facebook"
                    href={artistSocials.facebook}
                    className="relative w-10 h-10"
                    target="blank"
                  >
                    <Image
                      layout="fill"
                      src="/assets/icons/facebook.svg"
                      className="cursor-pointer"
                      alt="facebook"
                      blurDataURL="/assets/icons/facebook.svg"
                      placeholder="blur"
                    />
                  </a>
                </div>
              )}
              {artistSocials.instagram && (
                <div className="flex">
                  <a
                    id="socials-icon-instagram"
                    href={artistSocials.instagram}
                    className="relative w-10 h-10"
                    target="blank"
                  >
                    <Image
                      layout="fill"
                      src="/assets/icons/instagram.svg"
                      className="cursor-pointer"
                      alt="instagram"
                      blurDataURL="/assets/icons/instagram.svg"
                      placeholder="blur"
                    />
                  </a>
                </div>
              )}
              {artistSocials.twitter && (
                <div className="flex">
                  <a
                    id="socials-icon-x"
                    href={artistSocials.twitter}
                    className="relative w-10 h-10"
                    target="blank"
                  >
                    <Image
                      layout="fill"
                      src="/assets/icons/x.svg"
                      className="cursor-pointer"
                      alt="X"
                      blurDataURL="/assets/icons/x.svg"
                      placeholder="blur"
                    />
                  </a>
                </div>
              )}
            </>
          ) : (
            <span className="opacity-70 text-base">No Socials Available</span>
          )}
        </div>
      </div>
      <div className="space-y-4">
        <span className="opacity-70 text-base">Share this link</span>
        <div className="flex items-center pr-4 space-x-4 border-grayLight border-1 rounded-xl">
          <input
            id="share-input"
            type="text"
            className="w-full bg-transparent border-none focus:outline-none"
            value={getShareUrl()}
            disabled
          />
          <button onClick={handleCopyLink}>
            <Icon icon={copied ? Check : Copy} className={fill} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareLinks;
